import { Component, OnInit, ViewEncapsulation, Inject, Renderer2, ChangeDetectorRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { NgForm } from '@angular/forms';
import { DataService } from 'src/app/services/data.service';
import { Title, Meta } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Chart, registerables } from 'chart.js';
declare var $: any;


@Component({
  selector: 'app-wish-sip-vis',
  templateUrl: './wish-sip-vis.component.html',
  styleUrls: ['./wish-sip-vis.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class WishSipVisComponent implements OnInit {
  
  currentCalculator: 'sip' | 'lumsum' = 'sip';

  name: string = "";
  email: string = "";
  mobile: string = "";
  nameValidateMessage: any = '';
  emailValidateMessage: string = '';
  mobileValidateMessage: string = '';
  city: string = "";
  currentAge: string = "";
  currAgeValidateMessage: string = "";
  cityValidateMsg: string = "";


  intervalId: any;
  timeleft: number = 0;
  clickedResend: number = 0;
  resendBtnTimer = 3;
  isLeadFormVisible: boolean = true;
  isOtpFormVisible: boolean = false;
  isThanksVisible: boolean = false;
  changeMobile: boolean = false;
  userOTP: string = "";
  isTimer: boolean = true;
  isResend: boolean = false;

  displayMobile: string = '';
  otpVerifiedStatus: boolean = true;

  visitorId: any;
  leadId: string = '';

  otpValidateMessage: string = '';

  meta_title: string = '';
  meta_desc: string = '';
  meta_keywords: string = '';
  meta_image: string = '';

  hideSuggestion: boolean = false;
  pincode: string = "";
  pinValidateMessage: string = '';
  pincodeArr: any[] = [];
  isResendOTP: boolean = false;
  otpVerify: string = '';

  visitortype: any;

  Monthly_investment: any = 25000;
  monthlyexpect: any = 12;
  timeperiod: any = 10;
  P: number = 25000;
  R: number = 12;
  T: number = 10;
  calculate_value: any;
  total_value: any;
  total_investment_ammount: number = 0;
  estmated_return = 0;
  amount_errormsg: string = '';
  Expected_Rate_error: string = '';
  Time_period_error: string = '';
  checkedTerms: string = 'true';


  L_Monthly_investment: any = 1000000;
  L_monthlyexpect: any = 12;
  L_timeperiod: any = 10;

  LP: number = 1000000;
  LR: number = 12;
  LT: number = 10;
  L_calculate_value: any;
  L_total_value: any;
  L_total_investment_ammount: number = 0;
  L_estmated_return = 0;
  L_amount_errormsg: string = '';
  L_Expected_Rate_error: string = '';
  L_Time_period_error: string = '';

  newChartData: any[] = [];
  public chartType = 'doughnut';
  public chartData = [1804160, 2500000];
  public chartLabels = ['Principal Amount', 'Interest Amount'];
  public chartColors = [
    {
      backgroundColor: ['#ED1C24', '#FFC4C7'],
    },
  ];
  public chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
  };



  L_newChartData: any[] = [];
  public L_chartType = 'doughnut';
  public L_chartData = [1804160, 2500000];
  public L_chartLabels = ['Principal Amount', 'Interest Amount'];
  public L_chartColors = [
    {
      backgroundColor: ['#ED1C24', '#FFC4C7'],
    },
  ];
  public L_chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
  };

  constructor(@Inject(DOCUMENT) private document: Document, private route: ActivatedRoute, private service: DataService, private titleService: Title, private metaService: Meta, private renderer: Renderer2, private cdr: ChangeDetectorRef, private router: Router) {
    Chart.register(...registerables);
  }

  ngOnInit(): void {
    this.currentCalculator = 'sip';;
    this.calculation()
    this.calculation2();

    if (window.location.hash === '#calculator') {
      this.currentCalculator = 'sip';

      // Wait for DOM to render after setting currentCalculator
      setTimeout(() => {
        const el = document.getElementById('sipSection');
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        }
      }, 300); // Slight delay to ensure section is available
    }

    if (sessionStorage.getItem('visitorId')) {
      this.visitorId = '';
      sessionStorage.setItem('visitorId', '');
    }
    if (sessionStorage.getItem('leadId')) {
      this.leadId = '';
      sessionStorage.removeItem('leadId')
    }
    this.createVisitor();
    this.metaForSEO('wish-karo-sip-karo-vis');

    $('input[type="range"]').each(() => {
      $(this)[0].oninput = function () {
        var uMaxVal = $(this).attr('max');
        var uMinVal = $(this).attr('min'),
          uValu = this.value,
          // uCalc = (uValu * 100) / uMaxVal;
          uCalc = ((uValu - uMinVal) / (uMaxVal - uMinVal)) * 100;
        this.inflationrange = uValu.toString();
        $(this).siblings('.type-range').css('width', uCalc + '%');
        $(this).siblings('.thumb').css('left', uCalc + '%');
        if ($(this).parent().hasClass('retirement-custom-range')) {
          $(this).siblings('.thumbNew').text('');
        }
        if ($(this).parent().hasClass('retireCalc')) {
          $(this).siblings('.thumbNew').text(uValu + " ");
        }

      }
    });
    // document.getElementById("error_msg")!.style.display = "none";
    // document.getElementById("error_msg1")!.style.display = "none";
    // document.getElementById("error_msg2")!.style.display = "none";
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.currentCalculator === 'sip') {
        this.createChart(this.chartData);
      } else {
        this.createChart2(this.L_chartData);
      }
    }, 0);
  }

  showCalculator(type: 'sip' | 'lumsum'): void {
    this.currentCalculator = type;
    this.cdr.detectChanges(); // Ensure the view updates
    setTimeout(() => {
      if (type === 'sip') {
        this.createChart(this.chartData);
      } else {
        this.createChart2(this.L_chartData);
      }
    }, 0);
  }



  updateChartData(newData: number[]) {
    this.newChartData = newData;
    this.createChart(this.chartData);
  }


  updateChartData2(L_newData: number[]) {
    this.L_newChartData = L_newData;
    this.createChart(this.L_chartData);
  }

  createChart(chartDataSet: any) {
    const ctx: any = (document.getElementById('myChart') as HTMLCanvasElement).getContext('2d');
    var existingChart = Chart.getChart(ctx);

    // If an existing chart is found, destroy it
    if (existingChart) {
      existingChart.destroy();
    }

    const myChart = new Chart(ctx, {
      type: 'doughnut', // Replace with the desired chart type
      data: {
        // labels: ['Principal Amount', 'Interest Amount'],
        datasets: [
          {
            // label: 'My Dataset',
            data: chartDataSet,
            backgroundColor: ['#ED1C24', '#FFC4C7'],
            borderColor: ['#ED1C24', '#FFC4C7'],
            borderWidth: 1
          }
        ]
      },
      options: {
        maintainAspectRatio: false,
        // hover: {
        //   mode: 'nearest',
        //   intersect: true,
        // },
        // animation: {
        //   animateScale: true,
        //   animateRotate: false,
        // },
        tooltips: {
          callbacks: {
            label: function (tooltipItem: any, data: any) {
              return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
              // return label.toLocaleString(); // Format with commas
            },
            formatter: function (value: any, context: any) {
              return value.toString();
            }
          }
        }
      } as any
    });
  }


  createChart2(L_chartDataSet: any) {
    const ctx: any = (document.getElementById('myChart') as HTMLCanvasElement).getContext('2d');
    var L_existingChart = Chart.getChart(ctx);

    // If an existing chart is found, destroy it
    if (L_existingChart) {
      L_existingChart.destroy();
    }

    const myChart = new Chart(ctx, {
      type: 'doughnut', // Replace with the desired chart type
      data: {
        // labels: ['Principal Amount', 'Interest Amount'],
        datasets: [
          {
            // label: 'My Dataset',
            data: L_chartDataSet,
            backgroundColor: ['#ED1C24', '#FFC4C7'],
            borderColor: ['#ED1C24', '#FFC4C7'],
            borderWidth: 1
          }
        ]
      },
      options: {
        maintainAspectRatio: false,
        // hover: {
        //   mode: 'nearest',
        //   intersect: true,
        // },
        // animation: {
        //   animateScale: true,
        //   animateRotate: false,
        // },
        tooltips: {
          callbacks: {
            label: function (tooltipItem: any, data: any) {
              return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
              // return label.toLocaleString(); // Format with commas
            },
            formatter: function (value: any, context: any) {
              return value.toString();
            }
          }
        }
      } as any
    });
  }



  setInvestmentValue(event: any) {
    let val = event.target.value;
    document.getElementById("error_msg")!.style.display = "none";
    if (val < 500) {
      val = 500;
      this.amount_errormsg = "Minimum value allowed is 500";
      document.getElementById("error_msg")!.style.display = "block";
    } else if (val > 200000) {
      val = 200000;
      // this.amount_errormsg = "Maximum value allowed is 2,00,000";
      // document.getElementById("error_msg").style.display = "block";
    }

    this.P = val;
    var maxval = $('#monthlyRange').attr('max');
    var minval = $('#monthlyRange').attr('min');
    $('#monthlyRange').siblings('.thumb').css('left', ((val - minval) / (maxval - minval)) * 100 + '%');
    $('#monthlyRange').siblings('.type-range').css('width', ((val - minval) / (maxval - minval)) * 100 + '%');
  }

  setInvestmentValue2(event: any) {
    let val = event.target.value;
    document.getElementById('error_msg')!.style.display = 'none';
    if (val < 500) {
      val = 500;
      this.L_amount_errormsg = 'Minimum value allowed is 500';
      document.getElementById('error_msg')!.style.display = 'block';
    } else if (val > 2000000) {
      val = 2000000;
    }

    this.LP = val;
    var maxval = $('#monthlyRange').attr('max');
    var minval = $('#monthlyRange').attr('min');
    $('#monthlyRange')
      .siblings('.thumb')
      .css('left', ((val - minval) / (maxval - minval)) * 100 + '%');
    $('#monthlyRange')
      .siblings('.type-range')
      .css('width', ((val - minval) / (maxval - minval)) * 100 + '%');
  }


  setRateValue(event: any) {
    let val = event.target.value;
    document.getElementById("error_msg1")!.style.display = "none";
    if (val < 1) {
      val = 1;
      document.getElementById("error_msg1")!.style.display = "block";
      this.Expected_Rate_error = " Minimum value allowed is 1%";
    }
    else if (val > 30) {
      val = 30;
      // this.Expected_Rate_error =  "Maximum value allowed is 20%"
      // document.getElementById("error_msg1").style.display = "block";
    }

    this.R = val;
    var maxval = $('#monthlyrate').attr('max');
    var minval = $('#monthlyrate').attr('min');
    $('#monthlyrate').siblings('.thumb').css('left', ((val - minval) / (maxval - minval)) * 100 + '%');
    $('#monthlyrate').siblings('.type-range').css('width', ((val - minval) / (maxval - minval)) * 100 + '%');
  }


  setRateValue2(event: any) {
    let val = event.target.value;
    document.getElementById("error_msg1")!.style.display = "none";
    if (val < 1) {
      val = 1;
      document.getElementById("error_msg1")!.style.display = "block";
      this.L_Expected_Rate_error = " Minimum value allowed is 1%";
    }
    else if (val > 30) {
      val = 30;
    }

    this.LR = val;
    var maxval = $('#monthlyrate').attr('max');
    var minval = $('#monthlyrate').attr('min');
    $('#monthlyrate').siblings('.thumb').css('left', ((val - minval) / (maxval - minval)) * 100 + '%');
    $('#monthlyrate').siblings('.type-range').css('width', ((val - minval) / (maxval - minval)) * 100 + '%');
  }

  setTimeValue(event: any) {
    let val = event.target.value;
    document.getElementById("error_msg2")!.style.display = "none";
    if (val < 1) {
      this.Time_period_error = "Minimum value allowed is 1 year";
      document.getElementById("error_msg2")!.style.display = "block";
      val = 1;
    }
    else if (val > 30) {
      val = 30;
      // this.Time_period_error = "Maximum value allowed is 30 year";
      // document.getElementById("error_msg2").style.display = "block";
    }

    this.T = val;
    var maxval = $('#timerange').attr('max');
    var minval = $('#timerange').attr('min');
    $('#timerange').siblings('.thumb').css('left', ((val - minval) / (maxval - minval)) * 100 + '%');
    $('#timerange').siblings('.type-range').css('width', ((val - minval) / (maxval - minval)) * 100 + '%');
  }


  setTimeValue2(event: any) {
    let val = event.target.value;
    document.getElementById("error_msg2")!.style.display = "none";
    if (val < 1) {
      this.L_Time_period_error = "Minimum value allowed is 1 year";
      document.getElementById("error_msg2")!.style.display = "block";
      val = 1;
    }
    else if (val > 30) {
      val = 30;
    }

    this.LT = val;
    var maxval = $('#timerange').attr('max');
    var minval = $('#timerange').attr('min');
    $('#timerange').siblings('.thumb').css('left', ((val - minval) / (maxval - minval)) * 100 + '%');
    $('#timerange').siblings('.type-range').css('width', ((val - minval) / (maxval - minval)) * 100 + '%');
  }

  preventInput(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    // const value = inputElement.value;
    // const maxVal = inputElement.max;
    const value = parseInt(inputElement.value);
    const maxVal = parseInt(inputElement.max);
    if (value > maxVal) {
      inputElement.value = maxVal.toString();
    }
  }

  calculation() {
    // this.Monthly_investment = this.Monthly_investment ? this.Monthly_investment : 500;
    const P = this.P ? this.P : 500;
    // this.timeperiod = this.timeperiod ? this.timeperiod : 1;
    const T = this.T ? this.T : 1;
    // this.monthlyexpect = this.monthlyexpect ? this.monthlyexpect : 1;
    const R = this.R ? this.R : 1;

    const monthlyRate = R / 1200;
    const totalMonths = T * 12;
    this.total_investment_ammount = (P * totalMonths);
    this.calculate_value = Math.round(P * (Math.pow(1 + monthlyRate, totalMonths) - 1) / (monthlyRate) * (1 + monthlyRate));
    this.estmated_return = this.calculate_value - this.total_investment_ammount;
    this.chartData = [this.estmated_return, this.total_investment_ammount];
  }


  calculation2() {
    const P = this.LP ? this.LP : 500;
    const T = this.LT ? this.LT : 1;
    const R = this.LR ? this.LR : 1;

    // const monthlyRate = R ;
    const monthlyRate = R * 0.01;

    const timePeriod = T;
    this.L_total_investment_ammount = this.LP ? this.LP : 500;
    this.L_calculate_value = Math.round(P * Math.pow(1 + monthlyRate, T));
    // this.calculate_value = Math.round(P * (Math.pow(1 + monthlyRate, timePeriod) - 1) / (monthlyRate) * (1 + monthlyRate));
    this.L_estmated_return = this.L_calculate_value - this.L_total_investment_ammount;
    // this.chartData = [this.estmated_return,this.total_investment_ammount ];

    this.L_chartData = [this.L_estmated_return, this.L_total_investment_ammount];
    // console.log(this.chartData,'chartData');
  }

  monthlyInvestmentRangeVal() {
    this.P = this.Monthly_investment;
    document.getElementById("error_msg")!.style.display = "none";
  }

  monthlyInvestmentRangeVal2() {
    this.LP = this.L_Monthly_investment;
    document.getElementById("error_msg")!.style.display = "none";
  }
  monthlyTimeRangeVal() {
    this.T = this.timeperiod;
    document.getElementById("error_msg2")!.style.display = "none";
  }

  monthlyTimeRangeVal2() {
    this.LT = this.L_timeperiod;
    document.getElementById("error_msg2")!.style.display = "none";
  }
  monthlyRateRangeVal() {
    this.R = this.monthlyexpect;
    document.getElementById("error_msg1")!.style.display = "none";
  }

  monthlyRateRangeVal2() {
    this.LR = this.L_monthlyexpect;
    document.getElementById("error_msg1")!.style.display = "none";
  }

  chartHovered(event: any) {

  }



  metaForSEO(slugname: string): void {
    this.service.getDynamicMeta().subscribe(
      (data: any) => {
        const seoPages = data?.rows?.[0]?.seo_pages || [];

        seoPages.forEach((v: any) => {
          if (v.seo_slug === slugname || v.seo_slug === "/" + slugname) {
            this.meta_title = v.seo_title;
            this.meta_desc = v.seo_description;
            this.meta_keywords = v.seo_keywords;

            this.titleService.setTitle(this.meta_title);
            this.metaService.removeTag('name="keywords"');
            this.metaService.removeTag('name="description"');
            this.metaService.addTags([
              { name: 'keywords', content: this.meta_keywords },
              { name: 'description', content: this.meta_desc },
              { name: 'robots', content: 'index, follow' }
            ]);
          }
        });
      },
      (err) => {
        console.error('Error fetching SEO metadata:', err);
      }
    );
  }



  createVisitor() {
    let jscd = window['jscd'];
    if (!sessionStorage.getItem('visitorId')) {
      let obj = {
        "browsername": jscd?.browser,
        "browserversion": jscd?.browser + ' ' + jscd?.browserVersion,
        "operatingsystem": jscd?.os + " " + jscd?.osVersion,
        "device": jscd?.os,
        "sourceurl": window.location.href,
        "productid": '55',
        "visitortype": "wish-karo-sip-karo-vis",
        "utmsource": this.GetParameterValues("utm_source"),
        "utmmedium": this.GetParameterValues("utm_medium"),
        "leadsource": this.GetParameterValues("lead_source"),
        "utmcampaign": this.GetParameterValues("utm_campaign"),
      };
      this.visitortype = "wish-karo-sip-karo-vis"; // VISITOR TYPE
      this.service.createVisitor(obj).subscribe((data: any) => {
        this.visitorId = data["visitorId"];
        sessionStorage.setItem('visitorId', data["visitorId"])
      },
        err => {
          console.log(err);
          throw err;
        })
    } else {
      this.visitorId = sessionStorage.getItem('visitorId')
    }
  }

  MobileDisplayLabel(mobile: string) {
    this.displayMobile = `${mobile.substr(0, 2)}XXXXX${mobile.substr(7, 9)}`;
  }


  PostData(leadForm: NgForm) {
    document.getElementById('fill-form')!.style.display = 'none';
    console.log('Post')
    this.MobileDisplayLabel(this.mobile);
    this.createLead();
    this.isLeadFormVisible = false;
    this.isOtpFormVisible = true;
    this.isThanksVisible = false;
    this.isTimer = true;
    this.startTimer();
  }

  createLead() {
    let leadid = sessionStorage.getItem('leadId');
    this.visitorId = sessionStorage.getItem('visitorId')
    let obj = {
      "visitorid": this.visitorId,
      "leadid": leadid ? leadid : 0,
      "name": this.name,
      "mobile": this.mobile,
      "email": this.email,
      "currAge": this.currentAge,
      "pincode": this.pincode,
      "city": this.city
    }
    this.service.createLead(obj).subscribe((data: any) => {
      sessionStorage.setItem('leadId', data['leadid'])
      this.leadId = data['leadid'];
      // console.log('leadid:', this.leadId);
      this.sendOtp();
      if (!data['success']) {
      }
    }, err => {
      console.log(err);
    })
  }


  sendOtp() {
    this.service.sendOtp({ leadid: this.leadId, mobile: this.mobile }).subscribe(data => {
      console.log("Leadid", this.leadId);
    }, err => {
      console.log(err);
    })
  }

  SubmitOTP(otpForm: NgForm) {
    this.userOTP = otpForm.value.otp;
    if (this.userOTP) {
      this.VerifyOTP();
    }
    else {
      this.otpValidateMessage = "required";
    }
  }


  VerifyOTP() {
    $("#otp_verify_btn").attr("disabled", "true");
    document.getElementById("main_loader")!.style.display = 'block';
    //this.isResend = false;
    this.service.verifyOtp({ leadid: this.leadId, otp: this.userOTP }).subscribe(data => {
      if (data["success"]) {
        $("#otp_verify_btn").removeAttr("disabled");

        document.getElementById("main_loader")!.style.display = 'none';
        sessionStorage.removeItem('leadId')
        let verifystatus = true;
        sessionStorage.setItem('formSubmitted', 'true');
        this.redirectTo(verifystatus);

        let utm_source = this.GetParameterValues("utm_source");
        let utm_medium = this.GetParameterValues("utm_medium");
        let lead_source = this.GetParameterValues("lead_source");
        let utm_campaign = this.GetParameterValues("utm_campaign");


        this.service.pushLeadToLSQ(
          {
            visitor_type: this.visitortype,
            Name: this.name,
            Mobile: this.mobile,
            Email: this.email,
            Campaign_Name: 'WishKaroSipKaro_VIS',
            Landing_Page_URL: window.location.href,
            LEADID: this.leadId,
            Pincode: this.pincode,
            City: this.city,
            Age: this.currentAge,
            Product: "Mutual Funds",
            Sub_LeadSource: utm_source ? utm_source : "",
            Utm_Source: utm_source ? utm_source : 'Websites',
            Utm_Medium: utm_medium ? utm_medium : '',
            Utm_Campaign: utm_campaign ? utm_campaign : '',
            LeadSource: 'Digital Marketing',
            Entity_Type: 'Digital_BCL',
          }
        ).subscribe((res: any) => {
          if (res["success"]) {
            let sfid = res['id'];
          }
        });
        this.leadId = '';

      } else {
        $("#otp_verify_btn").removeAttr("disabled");
        document.getElementById("main_loader")!.style.display = 'none';
        sessionStorage.setItem('formSubmitted', 'false');
        this.otpVerifiedStatus = false;
      }
    }, err => {
      $("#otp_verify_btn").removeAttr("disabled");
      console.log(err);
    })
  }

  backbtn() {
    console.log('backbtn')
    this.isLeadFormVisible = true;
    this.isOtpFormVisible = false;
  }

  redirectTo(resp: any) {
    if (resp == true) {
      // this.isThanksVisible = true;
      this.router.navigate(['/wish-karo-sip-karo-vis/thankyou']);
      this.isLeadFormVisible = false;
      this.isOtpFormVisible = false;
    }
    else {
      this.otpVerifiedStatus = false;
    }

  }



  startTimer() {
    clearInterval(this.intervalId);
    this.otpVerifiedStatus = true;
    this.timeleft = 20;
    this.timeleft -= 1;
    this.intervalId = setInterval(() => {
      if (this.timeleft == 0 && this.isOtpFormVisible == true) {
        if (this.clickedResend === this.resendBtnTimer) {
          this.isResend = false;
        }
        if (this.clickedResend > 0 && this.clickedResend < this.resendBtnTimer) {
          this.isResend = true;
        }
        this.isTimer = false;
        clearInterval(this.intervalId);
        if (this.clickedResend == 0) {
          this.isResend = true;
        }
      }
      this.timeleft -= 1;
    }, 1000);
  }


  resendOTP() {
    $("#otp_verify_btn").removeAttr("disabled");
    //this.leadForm.controls['otp'].reset();
    this.userOTP = "";
    this.clickedResend++;
    this.isResendOTP = true;
    this.sendOtp();
    //this.leadForm.setErrors(null);
    this.startTimer();
    this.isTimer = true;
    this.isResend = false;
  }

  changeNumber() {
    $("#otp_verify_btn").removeAttr("disabled");
    this.userOTP = "";
    this.clickedResend = 0;
    this.changeMobile = true;
    this.isResend = false;
    this.isTimer = false; // to hide timer  
    // this.leadForm.setErrors({ 'incorrect': true });
    this.isLeadFormVisible = true;
    this.isOtpFormVisible = false;
    this.mobile = "";
  }

  removeErrorMsg(fieldname: string) {

    if (fieldname == "otp") {
      this.otpValidateMessage = "";
      this.otpVerifiedStatus = true; // to remove Invalid OTP message
    }
    if (fieldname == "name") {
      this.nameValidateMessage = "";
    }
    if (fieldname == "email") {
      this.emailValidateMessage = "";
    }
    if (fieldname == "mobile") {
      this.mobileValidateMessage = "";
    }
    if (fieldname == "city") {
      this.cityValidateMsg = "";
    }
    if (fieldname == "currentage") {
      this.currAgeValidateMessage = "";
    }

  }


  checkValidationMsg(leadForm: NgForm) {
    console.log('Checking')
    let num: number = 0;
    this.name = leadForm.value.name.trim();
    this.email = leadForm.value.email.trim();
    this.mobile = leadForm.value.mobile.trim();
    this.currentAge = leadForm.value.currentAge.trim();
    this.city = leadForm.value.city.trim();
    this.pincode = leadForm.value.pincode.trim();

    if (this.name && this.name.length < 3) {
      this.nameValidateMessage = "lengthError";
      num += 1;
    }
    if (!this.name) {
      this.nameValidateMessage = "required";
      num += 1;
    }
    if (this.email && this.validateEmailAddress(this.email) == 0) {
      this.emailValidateMessage = "invalid";
      num += 1;
    }
    if (!this.email) {
      this.emailValidateMessage = "required";
      num += 1;
    }
    if (this.isMobileWrong(this.mobile) == 0) {
      this.mobileValidateMessage = "invalid";
      num += 1;
    }
    if (!this.mobile) {
      this.mobileValidateMessage = "required";
      num += 1;
    }
    if (this.mobile && this.mobile.length != 10) {
      this.mobileValidateMessage = "lengthError";
      num += 1;
    }

    if (!this.city) {
      this.cityValidateMsg = "required";
      num += 1;
    }

    if (!this.pincode) {
      this.pinValidateMessage = "required";
      num += 1;
    }
    if (this.pincode && this.pincode.length != 6) {
      this.pinValidateMessage = "invalid";
      num += 1;
    }
    if (this.pincodeArr.length == 0) {
      this.pinValidateMessage = "invalid";
      num += 1;
    }

    if (!this.currentAge) {
      this.currAgeValidateMessage = "required";
      num += 1;
    }
    if (parseInt(this.currentAge) < 18 || parseInt(this.currentAge) > 99) {
      this.currAgeValidateMessage = "invalid";
      num += 1;
    }

    if (num > 0) {
      return false;
    } else {
      return true;
    }
  }



  otpValidate() {
    console.log('otpValidate')
    let num: number = 0;
    if (this.userOTP && this.userOTP.length != 6) {
      this.otpValidateMessage = "lengthError";
      num += 1;
    }
    if (num > 0) {
      return false;
    }
    return;
  }

  validateEmailAddress(email: string) {
    if (email) {
      var lastChars = email.lastIndexOf(".");
      var expression = /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
      if (!expression.test(String(email).toLowerCase()) || email.substring(lastChars, 3).length < 3) {
        return 0;
      }
      else {
        return 1;
      }
    }
    return
  }

  isMobileWrong(mobile: string) {
    let firstDigit = mobile.substring(0, 1);
    if (firstDigit != '6' && firstDigit != '7' && firstDigit != '8' && firstDigit != '9') {
      return 0;
    }
    else if (mobile.match(/^(\d)\1+$/g)) {
      return 0;
    }
    else {
      return 1;
    }
  }


  openSuggestionBox(event: Event, flag: string) {
    const target = event.target as HTMLInputElement | null;
    if (target && target.value.length > 0) { // Ensure target is not null
      if (flag === 'form') {
        this.hideSuggestion = true;
      }
    }
  }
  hideSuggestionDiv(flag: string) {
    if (flag == 'form') {
      this.hideSuggestion = false;
      if (this.pincode) {
        this.pinValidateMessage = "";
      }
    }
  }

  getPincodeList(event: Event, flag: string) {
    const pincode = (event.target as HTMLInputElement).value; // Safely access the value of the input
    if (flag === 'form') {
      if (pincode.length <= 3) {
        this.hideSuggestion = false;
      }
      this.service.cityFiler(pincode).subscribe((response: any) => {
        if (pincode.length > 3) {
          this.hideSuggestion = true;
          this.pincodeArr = response['data']; // pincode | citycode | cityname
          if (this.pincodeArr.length === 0) {
            this.pinValidateMessage = "invalid";
          }
        }
      })
    }

  }

  setpincode(pinObj: any, flag: string) {
    if (flag == 'form') {
      //this.citycode = pinObj.citycode;
      this.pincode = pinObj.pincode;
      this.hideSuggestion = false;
    }
  }
  alphaOnly(event: any) {
    var key = event.keyCode;
    return ((key >= 65 && key <= 90) || (key == 8 || key == 32));
  };

  numbersOnly($event: any) {
    if ($event.target.value.length === 0) {
      if ($event.key === '0' || $event.key === '1' || $event.key === '2' || $event.key === '3' || $event.key === '4' || $event.key === '5') {
        return false;
      }
    }
    var reg = /^[0-9]+$/;
    return (reg.test($event.key));
  };

  numberspincode($event: any) {
    if ($event.target.value.length === 0) {
      if ($event.key === '0') {
        return false;
      }
    }
    var reg = /^[0-9]+$/;
    return (reg.test($event.key));
  };

  numbersOnlyotp($event: any) {
    return /^[0-9]$/.test($event.key);
  };

  GetParameterValues(param: string) {
    var url = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for (var i = 0; i < url.length; i++) {
      var urlparam = url[i].split('=');
      if (urlparam[0] == param) {
        return urlparam[1];
      }
    }
    return
  }

  scrolltop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

}

